import { defaultModules, moduleRoutes, modules, searchRoutes } from '../../constants';
import {
    officeBreakdownRoute as mDOfficesBreakdownRoute,
    baseRoute as mDRoute,
    listingsBreakdownRoute as mdListingsBreakdownRoute,
    officeBreakdownRoute,
    officeListingsRoute
} from '../../market-dynamics/constants/routes';
import { Routes } from '../routes/routes';

//This function will retrieve the route of the first tool App depending on user permissions.
export const getFirstToolRoute = (allowedModules, isDashboardEnabled) => {
    if (isDashboardEnabled) return moduleRoutes[modules.dashboard.dashboard];
    return moduleRoutes[getFirstDefaultModule(allowedModules)];
};

export const getFirstDefaultModule = (allowedModules) => {
    const [_, defaultModule] = Object.entries(defaultModules).find(([key]) => {
        return allowedModules?.includes(key);
    });
    return defaultModule;
};

export const getAllowedModuleByUrl = ({ url, allowedModules, modulesByRouteAndNameAssociation }) => {
    const moduleByUrl = modulesByRouteAndNameAssociation.find(({ route }) => route === url);
    if (allowedModules?.includes(moduleByUrl?.moduleName)) {
        return moduleByUrl?.module;
    }
    return getFirstDefaultModule(allowedModules);
};

export const maskUrlVar = value => encodeURIComponent(value);
export const unmaskUrlVar = value => decodeURIComponent(value);

export const backButtonConfig = {
    [mDOfficesBreakdownRoute]: (history) => {
        history.replace(Routes.MARKET_DYNAMICS.BASE);
    },
    [mdListingsBreakdownRoute]: (history) => {
        history.replace(Routes.MARKET_DYNAMICS.BASE);
    },
    [officeListingsRoute]: (history) => {
        history.replace(officeBreakdownRoute);
    },
    [searchRoutes.agentsGainedBreakdown]: (history, altBackRoute) => {
        history.replace(altBackRoute || searchRoutes.agentMovement);
    },
    [searchRoutes.officeListBreakdown]: (history) => {
        history.replace(searchRoutes.agentMovement);
    },
};

export const backButtonByRoute = Object.freeze({
    [mDOfficesBreakdownRoute]: (history) => history.replace(Routes.MARKET_DYNAMICS.BASE),
    [mdListingsBreakdownRoute]: (history) => history.replace(Routes.MARKET_DYNAMICS.BASE),
});

export const exportModalByRoute = [
    mDRoute,
    searchRoutes.totals,
    searchRoutes.coverage,
    searchRoutes.agentMovement,
    searchRoutes.agentDetail,
    searchRoutes.agentProduction,
];
